/* eslint-disable */

import OLDrawInteraction from 'ol/interaction/Draw';
import OLSnapInteraction from 'ol/interaction/Snap';
import OLModifyInteraction from 'ol/interaction/Modify';

import {drawAllSectors, drawTempSector} from './draw-sectors';
import {calculateLength as calcLength} from './length';
import {calcPaintFaiTriangle as baseCalcPaintFaiTriangle} from './fai';

export default (map, drawing, sector, faiVectorSource, isFaiEnabled, setLength, setFAILength, onFinishDrawing, setWaypoints) => {
    let isDrawing, isModifying, isTempSectorVisible = false;
    let myWaypointsArr;
    let draw;

    const setDrawing = value => isDrawing = value;

    const finishDrawing = () => {
        draw.finishDrawing();
        onFinishDrawing();
    };

    function addInteractions() {
        let snap, modify;

        if (!isDrawing) {
            draw = new OLDrawInteraction({
                source: drawing,
                type: isFaiEnabled() ? 'Polygon' : 'MultiLineString',
                stopClick: false, // click Events waehrend des Zeichnens nicht erlauben
            });

            map.addInteraction(draw);

            // Die beiden Events, die das Zeichnen eines Features propagieren
            draw.on('drawstart', function () {
                setDrawing(true);
                setWaypoints(myWaypointsArr = []);
            });
            draw.on('drawend', function () {
                setDrawing(false);
            });

            snap = new OLSnapInteraction({
                source: drawing,
                pixelTolerance: 20
            });
            map.addInteraction(snap);

            modify = new OLModifyInteraction({
                source: drawing,
            });
            map.addInteraction(modify);

            modify.on('modifystart', function () {
                isModifying = true;
            });

            modify.on('modifyend', function () {
                isModifying = false;
            });

        }
    }

    drawing.on('addfeature', function ({feature}) {
        let coords = feature.getGeometry().getCoordinates(); // Array aus Koordinatenpaar-Arrays

        coords = coords[0];

        // Die aktuellen Feature Punkte in den lokalen Array Schreiben
        setWaypoints(myWaypointsArr = coords);

        sector.clear(); // Entfernt alle hier evtl. noch eingezeichneten temporaeren Sektoren
        setDrawing(false);

        if (myWaypointsArr.length >= 3 && isFaiEnabled()) {
            drawAllSectors(sector, coords); // Zeichnet die endgueltigen Sektoren ein
        }

		map.removeInteraction(draw);

        //calcPaintFaiTriangle(coords);

        let myLength = calcLength(myWaypointsArr);

        setLength(myLength);
    });

    const calcPaintFaiTriangleTimer = 0;
    const onNextFrame = window.requestAnimationFrame || (callback => setTimeout(callback, 0));
    const cancelOnNextFrame = window.cancelAnimationFrame || clearTimeout;

    drawing.on('changefeature', function ({feature}) {
        let coords = feature.getGeometry().getCoordinates(); // Array aus Koordinatenpaar-Arrays

        coords = coords[0];

        if (isFaiEnabled()) {
            const [first, ...others] = coords;
            coords = [first, ...others, first];
        }

        // Die Aenderung in den lokalen Array Schreiben, also die Koordinaten aller Eckpunkte
        setWaypoints(myWaypointsArr = coords);

        if (isFaiEnabled()) {
            cancelOnNextFrame(calcPaintFaiTriangleTimer);
            onNextFrame(() => {
                const corners = calcPaintFaiTriangle(coords);

                if (corners) {
                    const [first, second, third] = corners;
                    drawAllSectors(sector, [first, second, third, first]);
                } else {
                    sector.clear();
                }
            });
        }

        let myLength = calcLength(myWaypointsArr);

        setLength(myLength);
    });

    // Button
    function startDrawing() {
        drawing.clear();
        sector.clear();
        faiVectorSource.clear();
        addInteractions();
        setLength(0);
        setFAILength(0);
    }

    // Button
    function stopDrawing() {
        finishDrawing();
        map.removeInteraction(draw);
    }

    /*
        Die Maus bewegt sich oder der Pointer auf dem Touchscreen (beim Zoomen und draggen der Karte)
    */
    map.on('pointermove', function ({coordinate}) {
        let myTmpLengthArr = []; // Bei jeder Pointerbewegung wird der temporaere Array fuer die Eckpunkte neu erstellt

        // Wenn der erste Punkt gesetzt wurde, dann..
        if (isDrawing) {

            // Wenn der erste Schenkel gerade gezeichnet wird, also Punkt 2 noch nicht festgelegt ist,
            // dann Zeige die zwei temporaeren Sektoren an.
            if (myWaypointsArr.length === 1 && isFaiEnabled()) {
                let myTempPointsArray = [myWaypointsArr[0], coordinate];
                drawTempSector(sector, myTempPointsArray);
            }

            if (myWaypointsArr.length >= 1) {
                myTmpLengthArr = myWaypointsArr.slice(); // Klone den aktuellen Array mit den Eckpunkten zum temporaeren LaengenArray
                myTmpLengthArr.push(coordinate); // Fuege dem temporaeren Array die aktuelle MausPos als letzten Punkt hinzu
                let myLength = calcLength(myTmpLengthArr); // Berechne die Laenge der LineStrings aus dem temp LaengenArray
                setLength(myLength);
            }
        }
    });

    map.on('click', function ({coordinate}) {
        if (isDrawing) {
            myWaypointsArr.push(coordinate);

            if (myWaypointsArr.length === 1 && isFaiEnabled()) {
                let myTempPointsArray = [myWaypointsArr[0], coordinate];
                drawTempSector(sector, myTempPointsArray);
                isTempSectorVisible = true;
            }

            if (myWaypointsArr.length === 3 && isFaiEnabled()) {
                // setze Punnkt 1 im coords Array als Endpunkt und zeichne das Polygon
                myWaypointsArr.push(myWaypointsArr[0]);

                finishDrawing();
            }

            // Wenn der Schenkel 1 und 2 festgelegt sind, dann kann der temporaere Sektor verschwinden
            if (myWaypointsArr.length === 3 && isTempSectorVisible && isFaiEnabled()) {
                sector.clear();
                isTempSectorVisible = false;
            }
        }
    });

    // ESC - Taste loescht letzten Punkt waehrend des malens
    const handleEscape = ({key}) => {
        if (isDrawing) {
            if (key === 'Escape') {
                draw.removeLastPoint();
                if (myWaypointsArr.length > 0) {
                    myWaypointsArr.pop();
                }
            }
        }
    };

    function calcPaintFaiTriangle(coords) {
        faiVectorSource.clear();

        const [length, corners] = baseCalcPaintFaiTriangle(faiVectorSource, coords);

        setFAILength(length);

        return corners;
    }

    return {handleEscape, startDrawing, stopDrawing};
}
